<template>
  <!-- Single root avoids "insertBefore, parent is null" when viewport or loading state changes -->
  <div class="login-page-root">
    <LottieLoader
      v-if="loading"
      type="login"
      :user-type="identifier.includes('@proweaver') ? 'user' : 'client'"
    />
    <div
      v-else
      class="flex min-h-screen flex-col bg-gradient-to-r from-[#F9F9FF] to-[#EDF3FF]"
    >
      <main
        class="flex flex-1 flex-col items-center justify-center px-4 sm:px-8 lg:flex-row"
      >
        <!-- Left: Login Card -->
        <div class="flex w-full justify-center py-12 lg:w-1/2 lg:py-20">
          <div
            class="login-ui relative grid w-full max-w-xl overflow-hidden rounded-3xl bg-white py-12 shadow-sm sm:px-16"
          >
            <!-- Optional decorative gradient blob behind card -->
            <!-- <div
            class="absolute -top-20 -right-20 w-72 h-72 bg-gradient-to-tr from-purple-300 to-blue-300 rounded-full opacity-20 filter blur-2xl"
          /> -->

            <!-- Card content -->
            <div
              class="relative z-10 mb-8 flex flex-col items-center text-center"
            >
              <img
                src="../assets/dms-logo.png"
                alt="DM Suite Logo"
                class="mb-12 h-8 w-auto"
              >

              <h2 class="text-2xl font-semibold sm:text-3xl">
                Log in to your Account
              </h2>
            </div>

            <form
              class="relative z-10 space-y-5"
              @submit.prevent="handleLogin"
            >
              <!-- Email -->
              <input
                id="login-username"
                v-model="email"
                name="username"
                autocomplete="username"
                type="email"
                placeholder="Email address"
                required
                class="w-full px-4 py-3 border border-gray-200 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
              >

              <!-- Password -->
              <div class="relative">
                <input
                  id="login-password"
                  v-model="password"
                  name="password"
                  autocomplete="current-password"
                  :type="showPassword === 'password' ? 'text' : 'password'"
                  placeholder="Password"
                  required
                  class="w-full px-4 py-3 border border-gray-200 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                >
                <button
                  v-if="showPassword === 'text'"
                  type="button"
                  class="absolute inset-y-0 right-4 flex items-center text-gray-400"
                  aria-label="Hide password"
                  @click="showPasswordtoggle"
                >
                  <i class="fas fa-eye-slash" />
                </button>
                <button
                  v-if="showPassword === 'password'"
                  type="button"
                  class="absolute inset-y-0 right-4 flex items-center text-gray-400"
                  aria-label="Show password"
                  @click="hidePasswordtoggle"
                >
                  <i class="fas fa-eye" />
                </button>
              </div>

              <button
                type="submit"
                :disabled="authenticating"
                class="w-full py-3 rounded-md text-white font-semibold bg-blue-500 px-6 hover:bg-blue-600 duration-300 ease-in-out shadow-lg hover:from-blue-600 hover:to-indigo-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span v-if="!authenticating">Log in</span>
                <span v-else>Logging in...</span>
              </button>

              <!-- Remember + Forgot -->
              <div class="flex items-center justify-between text-sm">
                <label class="flex items-center gap-2">
                  <input
                    id="remember-me"
                    v-model="remember"
                    name="remember"
                    type="checkbox"
                    class="form-checkbox text-blue-600"
                  >
                  Remember me
                </label>
                <!-- <a href="#" class="text-blue-500 hover:underline"
                >Forgot password?</a
              > -->
              </div>

              <!-- Error -->
              <div
                v-if="error"
                class="text-red-500 text-sm text-center"
              >
                {{ error }}
              </div>
            </form>

            <!-- <p class="mt-6 text-sm text-center relative z-10">
          Don’t have an account?
          <a href="/register" class="text-blue-500 hover:underline">Sign Up</a>
        </p> -->
          </div>
        </div>

        <!-- Right: Illustration (desktop only) -->
        <div class="hidden w-1/2 justify-center px-8 py-12 lg:flex">
          <div class="relative w-full max-w-2xl">
            <h3 class="mb-4 text-center text-xl font-semibold">
              Digital Marketing Suite
            </h3>
            <img
              src="../assets/DMSuite_Login_Illustration.svg"
              alt="Illustration"
              class="rounded-lg"
            >
            <!-- <div class="absolute top-4 right-4 bg-white p-4 rounded-lg shadow-md">
          <p class="text-sm text-gray-600">Inbox</p>
          <p class="text-2xl font-bold text-blue-500">1258</p>
          <p class="text-sm text-green-500">Unread</p>
        </div>
        <div class="absolute bottom-4 left-4 bg-white p-4 rounded-lg shadow-md">
          <p class="text-sm text-gray-600">Tasking</p>
          <p class="text-2xl font-bold text-red-500">18</p>
          <p class="text-sm text-orange-500">Overdue</p>
        </div> -->
          </div>
        </div>
      </main>

      <footer class="bg-[#304563] px-5 py-5 sm:px-8">
        <div
          class="mx-auto flex max-w-screen-xl 2xl:max-w-screen-xl xl:max-w-screen-lg lg:max-w-screen-lg flex-col items-center justify-between gap-5 sm:flex-row"
        >
          <nav
            class="flex items-center text-base font-semibol sm:text-md text-white/80 underline"
            aria-label="Legal information"
          >
            <button
              type="button"
              class="px-4 py-1 hover:text-white hover:font-semibold transition-all sm:px-6"
              @click="openLegalDocument('privacy_policy')"
            >
              Privacy Policy
            </button>
            <div>
              <span class="border-x border-white/60 py-1 transition" />
            </div>
            <button
              type="button"
              class="px-4 py-1 transition hover:text-white hover:font-semibold transition-all sm:px-6"
              @click="openLegalDocument('terms_and_conditions')"
            >
              Terms & Conditions
            </button>
          </nav>

          <div class="flex items-center gap-4">
            <span
              class="text-white/65 text-[0.65rem] font-bold uppercase tracking-[0.16em]"
            >
              Powered by
            </span>
            <img
              src="../assets/proweaver-powered-logo.png"
              alt="Proweaver — Affordable, Dependable, Fast"
              class="h-auto w-[13rem] sm:w-[15rem]"
            >
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import LottieLoader from "../components/loader/LottieLoader.vue";
import { eventBus } from "@/eventBus";
import { useAuthStore } from "@/store/auth";
import {
  isBlockedInternalUser,
  redirectAfterLogin,
} from "@/utils/authRedirect";

const REMEMBER_EMAIL_KEY = "remembered_user_email";

export default {
  name: "LoginPage",
  components: {
    LottieLoader,
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  data() {
    return {
      email: "",
      password: "",
      showPassword: "text",
      authenticating: false,
      loading: false,
      error: null,
      remember: false,
      identifier: "",
    };
  },
  mounted() {
    const saved = localStorage.getItem(REMEMBER_EMAIL_KEY);
    if (saved) {
      this.email = saved;
      this.remember = true;
    }
  },
  methods: {
    openLegalDocument(key) {
      this.router.push(
        key === "terms_and_conditions"
          ? "/terms-and-conditions"
          : "/privacy-policy"
      );
    },
    showPasswordtoggle() {
      this.showPassword = "password";
    },
    hidePasswordtoggle() {
      this.showPassword = "text";
    },
    async handleLogin() {
      if (!this.email || !this.password) {
        alert("Email and Password are required.");
        return;
      }

      this.authenticating = true;
      this.error = null;
      this.identifier = this.email.toLowerCase();

      const authStore = useAuthStore();

      try {
        await authStore.login({
          email: this.email,
          password: this.password,
          remember: this.remember,
        });

        if (this.remember) {
          localStorage.setItem(REMEMBER_EMAIL_KEY, this.email);
        } else {
          localStorage.removeItem(REMEMBER_EMAIL_KEY);
        }

        if (authStore.accountType === "internal_user") {
          eventBus.emit("admin-logged-in");
          window.dispatchEvent(new Event("admin-logged-in"));
        }
        if (authStore.accountType === "client") {
          eventBus.emit("client-logged-in");
          window.dispatchEvent(new Event("client-logged-in"));
        }

        if (
          (authStore.accountType === "internal_user" &&
            !isBlockedInternalUser(authStore)) ||
          authStore.accountType === "client"
        ) {
          this.loading = true;
        }

        if (isBlockedInternalUser(authStore)) {
          throw new Error("ACCESS_DENIED_LEVEL");
        }

        try {
          redirectAfterLogin(this.router, authStore);
        } catch (redirErr) {
          if (redirErr?.message === "ACCESS_DENIED_LEVEL") {
            this.error = "Your user level does not have access to DMSuite.";
          } else if (redirErr?.message === "ACCESS_DENIED") {
            this.error = "Access denied.";
          } else {
            throw redirErr;
          }
          await authStore.logout();
        }
      } catch (error) {
        const msg =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message;
        this.error =
          typeof msg === "string"
            ? msg
            : "Sign-in failed. Check your credentials and try again.";
      } finally {
        this.authenticating = false;
      }
    },
  },
};
</script>

<style scoped>
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.bg-gradient-to-r {
  background: linear-gradient(to right, #faf8ff, #dfeaf7);
}
.rounded-lg {
  border-radius: 20px;
}

@media (max-width: 768px) {
  .login-ui {
    height: auto;
    width: 100%;
    padding: 1.5rem;
  }
}
</style>
